import { Flex } from '@aloft/toolkit-sui';

import { selectDepreciationSegmentsWithMainDwelling } from '../../../../redux/features/selectors/selectDepreciationSegmentsWithMainDwelling.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { RootState } from '../../../../redux/types.ts';
import { EffectiveAgeSliderInputs } from '../EffectiveAgeSlider/EffectiveAgeSliderInputs.tsx';

export const DepreciateSeparatelySliders = ({ activeId }: { activeId: string }) => {
  const segments = useAppSelector((state: RootState) =>
    selectDepreciationSegmentsWithMainDwelling(state, activeId),
  );

  return (
    <Flex flexDirection="column">
      {segments
        .filter((segment) => segment.enabled)
        .map((segment, idx) => {
          return (
            <Flex flexDirection="column" key={`${segment.label}-${idx}`}>
              <Flex paddingY=".5rem">
                <EffectiveAgeSliderInputs id={activeId} index={idx} {...segment} enabled />
              </Flex>
              <Flex height="1px" backgroundColor="strokeDefault" />
            </Flex>
          );
        })}
    </Flex>
  );
};
